import React from 'react';
import PropTypes from 'prop-types';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

class OrderServiceFee extends React.Component {
    static propTypes = {
        service_fee: PropTypes.object.isRequired,
        t: PropTypes.func.isRequired,
    };

    render() {
        const { t, service_fee } = this.props;
        return (
            <tr className="m2g-order-confirmation-item m2g-order-confirmation-service-fee">
                <td className="m2g-order-confirmation-item-thumbnail" />
                <td className="m2g-order-confirmation-item-content">
                    {t('order_service_fee')}
                </td>
                <td data-service_fee className="m2g-order-confirmation-item-total">
                    {t('common:price', { price: service_fee.getListPrice() })}
                </td>
            </tr>
        );
    }
}

export default forwardRefWithTranslation('order.confirmation')(OrderServiceFee);
